import { render, staticRenderFns } from "./TruformeIneligible.vue?vue&type=template&id=b3787e9e"
import script from "./TruformeIneligible.vue?vue&type=script&lang=js"
export * from "./TruformeIneligible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports